// A character's appearance travels as a small recipe (the PixelStory townkit, shared/kit.ts); every client
// draws the sprites itself. The server only checks that the recipe is valid.
import { sanitizeKit, toKit, type KitLook } from './kit.js';
import LEGACY_IDS from './data/legacy-ids.json';

export type Look = KitLook;

/** A clean look from what a client sent: a townkit look, or (older clients) a look from the previous engine,
 *  which is converted. Null if it can't be read. */
export function sanitizeLook(raw: unknown): Look | null {
  if (!raw || typeof raw !== 'object') return null;
  if ((raw as { v?: number }).v === 2) return sanitizeKit(raw);
  const ids = LEGACY_IDS as Record<string, string[]>;
  for (const [k, v] of Object.entries(raw as Record<string, unknown>)) {
    if (v !== null && typeof v === 'object') return null;
    if (ids[k] && typeof v === 'number' && (!Number.isInteger(v) || v < 0 || v >= ids[k].length)) return null;   // an old look with a part that never existed
  }
  return toKit(raw);
}
